<script>
  import { getWrittenName, splitNameAndPrice, toArray } from "../../utils/utilities";

  export let item;
  export let selectOption;
  export let unselectOption;
  export let currency;

  const isMultiple = item.multiple;
  const isBookingAdvanced = item.type === "selectBookingAdvanced";

  function isSelected(option) {
    if (isBookingAdvanced) {
      return item.selectVal === option;
    } else if (isMultiple) {
      return item.val?.split("||")?.includes(option);
    } else {
      return item.val === option;
    }
  }

  function toggleOption(option, event) {
    if (isBookingAdvanced) {
      if (item.selectVal === option) {
        item.selectVal = "";
        unselectOption(option, item, event.target);
      } else {
        item.selectVal = option;
        selectOption(option, item, event.target);
      }
    } else if (isMultiple) {
      let selected = item.val?.split("||") ?? [];
      if (selected.includes(option)) {
        selected = selected.filter((v) => v !== option);
        unselectOption(option, item, event.target);
      } else {
        selected.push(option);
        selectOption(option, item, event.target);
      }
      item.val = selected.filter(Boolean).join("||");
    } else {
      if (item.val === option) {
        item.val = "";
        unselectOption(option, item, event.target);
      } else {
        item.val = option;
        selectOption(option, item, event.target);
      }
    }
  }
</script>

<div class="chatwith-button-options" class:buttons-as-table={item.showAsTable}>
  {#each toArray(item.data) as option}
    <button type="button" class="chatwith-option-button {isSelected(option) ? 'selected' : ''}" on:click={(e) => toggleOption(option, e)}>
      <div class="chatwith-option-button-text">
        <span class="chatwith-option-button-name">
          {splitNameAndPrice(getWrittenName(option, item?.dataObject, item?.showPrices, currency, item?.showDurations)).name}
        </span>

        {#if item?.showPrices}
          <small class="chatwith-option-button-price">
            ({splitNameAndPrice(getWrittenName(option, item?.dataObject, item?.showPrices, currency)).price})
          </small>
        {/if}

        {#if item?.showDurations}
          <small class="chatwith-option-button-duration">
            ({splitNameAndPrice(getWrittenName(option, item?.dataObject, item?.showPrices, currency, item?.showDurations)).duration})
          </small>
        {/if}
      </div>
    </button>
  {/each}
</div>
